// ================================================= /
// ======   TABLE JS   ============================= /
// ================================================= /

/* global jQuery */

import { debounce } from 'throttle-debounce';
import gsap from 'gsap';

import animation from './animation';

/**
 * Class for controlling the filterable tables
 */
class DispatchSkinTable {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-table';
		this.headerSelector = `${this.selector}__header`;
		this.filterSelector = `${this.selector}__filter`;
		this.notFoundSelector = `${this.selector}__not-found`;
		this.notFoundInnerSelector = `${this.selector}__not-found-inner`;
		this.rowSelector = `${this.selector}__row`;
		this.rowInnerSelector = `${this.selector}__row-inner`;
		this.columnSelector = `${this.selector}__column`;

		this.shadedClass = 'is-shaded';
		this.notShadedClass = 'is-not-shaded';
		this.hiddenClass = 'is-hidden';
		this.emptyClass = 'is-empty';

		this.columnNameDataAttribute = 'column-name';

		this.eventNamespace = 'dispatchSkinTable';
		this.changeDebounce = 100;
		this.minValueLength = 2;
		this.notFoundAnimationDuration = 0.5;
		this.rowAnimationDuration = 0.5;

		this.tables = [];
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		this.tables = jQuery( this.selector );
		const filters = jQuery( this.filterSelector );

		if ( filters ) {

			this.events();
		}
	}

	/**
	 * Wires up events
	 */
	events() {

		// Filter change
		jQuery( '.site' ).on(
			`input.${this.eventNamespace}`,
			this.filterSelector,
			debounce(
				this.changeDebounce,
				this.handleFilterChange.bind( this )
			)
		);

		// Animation hooks

		animation.addHook(
			this.selector,
			this.resolveAnimation.bind( this )
		);
		animation.addHook(
			this.selector,
			this.resetAnimation.bind( this ),
			false
		);
	}

	/**
	 * Handles filter change.
	 */
	handleFilterChange( event ) {

		const filter = jQuery( event.target );
		const value = filter.val().trim();
		const table = filter.closest( this.selector );

		const rows = table.find( this.rowSelector )
			.removeClass( this.shadedClass )
			.removeClass( this.notShadedClass );

		if ( ! value ) {

			rows.each(
				function( index ) {
					this.showHideRow( rows.eq( index ) );
				}.bind( this )
			);
		}

		else if ( value.length > this.minValueLength ) {

			const columnName = filter.data( this.columnNameDataAttribute );

			rows.each(
				function( index ) {

					const row = rows.eq( index );

					const columnText = row.find( this.columnSelector + '[data-' + this.columnNameDataAttribute + '=' + columnName + ']' )
						.text()
						.trim();

					this.showHideRow(
						row,
						columnText.toLowerCase().indexOf( value.toLowerCase() ) !== -1
					);

				}.bind( this )
			);
		}

		const remainingRows = rows.not( '.' + this.hiddenClass );

		// Restore shading

		remainingRows.each(
			function( index, row ) {

				const hasHeader = table.find( this.headerSelector ).length;

				let classToAdd;

				if ( index + 1 & 1 ) {
					classToAdd = hasHeader ? this.notShadedClass : this.shadedClass;
				}
				else {
					classToAdd = hasHeader ? this.shadedClass : this.notShadedClass;
				}

				jQuery( row ).addClass( classToAdd );

			}.bind( this )
		);

		const notFound = table.find( this.notFoundSelector );
		const notFoundInner = notFound.find( this.notFoundInnerSelector );

		gsap.to(
			notFound,
			{
				duration: this.notFoundAnimationDuration,
				height: remainingRows.length
					? 0
					: notFoundInner.outerHeight(),
				onComplete: remainingRows.length
					? null
					: () => notFound.css( 'height', 'auto' )
			}
		);
	}

	/**
	 * Shows or hides a row.
	 */
	showHideRow( row, show = true ) {

		const toHeight = show
			? row.find( this.rowInnerSelector ).outerHeight()
			: 0;

		gsap.to(
			row,
			{
				duration: this.rowAnimationDuration,
				height: toHeight,
				onComplete: show
					? () => row.css( 'height', 'auto' )
					: null
			}
		);

		row[show ? 'removeClass' : 'addClass']( this.hiddenClass );
	}

	/**
	 * Animation callbacks
	 */
	resolveAnimation( table ) {

		gsap.to(
			table.find( this.rowSelector ),
			{ duration: 0.5, stagger: 0.1, opacity: 1, y: 0, filter: 'grayscale(0%) blur(0px)' }
		);
	}
	resetAnimation( table ) {

	}

}

const table = new DispatchSkinTable();
export default table;



// WEBPACK FOOTER //
// ./src/js/inc/table.js